export enum ConnexionStatusState {
    IDLE = -1,
    ONLINE = 1,
    OFFLINE = 0,
}
